import { useTheme } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { PrimaryButton, SecondaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';
import { VacancyCTAContainer, Right } from '../styles';

export interface VacanciesModalCTAButtonsProps {
  onClose: () => void;
}

export const VacanciesModalCTAButtons: React.FC<VacanciesModalCTAButtonsProps> = ({ onClose }) => {
  const theme = useTheme();

  return (
    <VacancyCTAContainer>
      <Right>
        <SecondaryButton
          dataTestId={ATSVacanciesModalTestIds.BACK_BUTTON}
          sx={{ ...secondaryButtonOverrideSx(theme), width: '46%', mr: 2 }}
          onClick={onClose}
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          dataTestId={ATSVacanciesModalTestIds.SAVE_BUTTON}
          type="submit"
          sx={{ ...primaryButtonOverrideSx(theme), width: '46%' }}
        >
          Save
        </PrimaryButton>
      </Right>
    </VacancyCTAContainer>
  );
};
